import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { reduxForm } from 'redux-form';
import { translate } from 'react-polyglot';

import getPossessiveForm from '../../helpers/possessive';
import { FormLabel, FormInput, FormCodeInput, FormFeedback, BaseForm } from '../form';
import { PrimaryButton, BorderlessButton } from '../buttons';
import Section from '../edu/Section';
import { ArrowLeft } from '../icons';
import { DIARY_PIN_SIZE } from './index';
import { email } from '../../helpers/formValidators';
import './DiarySetup.css';


function DiarySetup(props) {
  const {
    firstName,
    onSubmit,
    isLoading,
    isSetupComplete,
    showIncorrectMessage,
    t
  } = props;

  return (
    <div>
      <div className="page-header">
        <h1>
          {t('diary.ownersDiary', { owner: getPossessiveForm(firstName) })}
        </h1>
      </div>
      <Section colorScheme="red">
        <div className="container--content">
          {isSetupComplete ? (
            <div className="card diary-setup-card">
              <h3>{t('diarySetup.title')}</h3>
              <h5>{t('diarySetup.complete')}</h5>
              <NavLink className="text-link" to="/diary">
                <BorderlessButton
                  label={t('diarySetup.backToDiary')}
                  colorScheme="blue"
                  IconLeft={ArrowLeft}
                />
              </NavLink>
            </div>
          ) : (
            <div className="card diary-setup-card">
              <h3>{t('diarySetup.title')}</h3>
              <p>{t('diarySetup.pinDescription')}</p>
              <BaseForm
                className="diary-setup__form"
                onSubmit={onSubmit}
                noValidate
              >
                <FormLabel>{t('diary.pin')}</FormLabel>
                <FormCodeInput
                  name="pin"
                  fields={DIARY_PIN_SIZE}
                  type="number"
                />
                <FormLabel>{t('diary.email')}</FormLabel>
                <FormInput
                  required
                  name="email"
                  placeholder={t('diary.email')}
                  validate={email}
                  type="email"
                  id="diary.email"
                />
                
                <p className="text-note">{t('diarySetup.emailDescription')}</p>
                {showIncorrectMessage && (
                  <FormFeedback positive={false}>
                    {t('diarySetup.incorrect')}
                  </FormFeedback>
                )}
                <div>
                  <PrimaryButton
                    label={t('diarySetup.start')}
                    type="submit"
                    disabled={isLoading}
                    loading={isLoading}
                  />
                </div>
              </BaseForm>
            </div>
          )}
        </div>
      </Section>
    </div>
  );
}

DiarySetup.propTypes = {
  firstName: PropTypes.string.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  isButtonDisabled: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isSetupComplete: PropTypes.bool,
  showIncorrectMessage: PropTypes.bool,
  t: PropTypes.func.isRequired
};

export default reduxForm({ form: 'diarySetup' })(translate()(DiarySetup));



// WEBPACK FOOTER //
// ./src/components/diary/DiarySetup.js